import { render, staticRenderFns } from "./Customer-account.vue?vue&type=template&id=770f99dc"
import script from "./Customer-account.vue?vue&type=script&lang=js"
export * from "./Customer-account.vue?vue&type=script&lang=js"
import style0 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/vendor/styles/pages/account.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./Customer-account.vue?vue&type=style&index=2&id=770f99dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports